export * from './DetailsModalSearch'
export * from './ModalHeader'
export * from './CatalogDetailsModal'
export * from './PrimaryDetails'
export * from './ModalDetailTabs'
export * from './ModalNotes'
export * from './ModalCatalogItemSeasonSelectors'
export * from './CatalogSecondariesDetails'
export * from './DetailsNavToolbar'
export * from './CustomDetailsTemplate'
export * from './DetailsTemplates'


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/index.ts